var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#DEF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4098 17.1667C14.3551 17.1667 13.5 18.0217 13.5 19.0765V23.1667C13.5 25.0523 13.5 25.9951 14.0858 26.5809C14.6716 27.1667 15.6144 27.1667 17.5 27.1667H24.5C26.3856 27.1667 27.3284 27.1667 27.9142 26.5809C28.5 25.9951 28.5 25.0523 28.5 23.1667V19.0765C28.5 18.0217 27.6449 17.1667 26.5902 17.1667C26.2285 17.1667 25.8978 16.9623 25.7361 16.6388L24.8861 14.9389C24.6172 14.401 24.4827 14.132 24.241 13.9827C23.9994 13.8333 23.6987 13.8333 23.0973 13.8333H18.9027C18.3013 13.8333 18.0006 13.8333 17.759 13.9827C17.5173 14.132 17.3828 14.401 17.1139 14.9389L16.2639 16.6388C16.1022 16.9623 15.7715 17.1667 15.4098 17.1667ZM23.3333 21.3333C23.3333 22.622 22.2887 23.6667 21 23.6667C19.7113 23.6667 18.6667 22.622 18.6667 21.3333C18.6667 20.0447 19.7113 19 21 19C22.2887 19 23.3333 20.0447 23.3333 21.3333ZM24.3333 21.3333C24.3333 23.1743 22.8409 24.6667 21 24.6667C19.1591 24.6667 17.6667 23.1743 17.6667 21.3333C17.6667 19.4924 19.1591 18 21 18C22.8409 18 24.3333 19.4924 24.3333 21.3333Z",
    fill: "#3DB2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.c0ecf637bf7a927107b8be53df2b4659.svg";
export { ForwardRef as ReactComponent };